/**
 * Печать графика в PDF (ПЛ-29): формат листа A4–A1, базовый план, только критические, подписи в штампе.
 */
import { useState } from 'react';
import { Button } from '../../ui/button';
import { Dialog } from '../../ui/dialog';
import { Checkbox, Input, Select } from '../../ui/form';
import { LField } from './LField';

export function PrintDialog({ scheduleId, onClose }: { scheduleId: string; onClose: () => void }) {
  const [f, setF] = useState({
    paper: 'A3',
    baseline: true,
    critical: false,
    made: '',
    checked: '',
    approved: '',
  });
  const q = new URLSearchParams({
    paper: f.paper,
    baseline: f.baseline ? '1' : '0',
    critical: f.critical ? '1' : '0',
  });
  for (const k of ['made', 'checked', 'approved'] as const) if (f[k].trim()) q.set(k, f[k].trim());
  const href = `/api/v1/schedules/${scheduleId}/print.pdf?${q}`;
  return (
    <Dialog
      open
      onOpenChange={(o) => !o && onClose()}
      title="Печать графика в PDF"
      description="Таблица работ и диаграмма на листах выбранного формата, с легендой и штампом."
      width="sm"
      footer={
        <>
          <Button onClick={onClose} className="max-md:h-11">
            Отмена
          </Button>
          <a
            href={href}
            target="_blank"
            rel="noopener"
            onClick={onClose}
            className="inline-flex min-h-11 items-center rounded-md bg-ink px-4 text-[14px] font-medium text-surface md:min-h-9"
          >
            Скачать PDF
          </a>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <LField label="Формат листа">
          <Select
            value={f.paper}
            onChange={(e) => setF({ ...f, paper: e.target.value })}
            className="max-md:h-11"
          >
            <option value="A4">A4, альбомный</option>
            <option value="A3">A3, альбомный</option>
            <option value="A2">A2, альбомный</option>
            <option value="A1">A1, альбомный</option>
          </Select>
        </LField>
        <Checkbox
          className="min-h-11 items-center md:min-h-0"
          label="Базовый план под полосами"
          checked={f.baseline}
          onChange={(e) => setF({ ...f, baseline: e.target.checked })}
        />
        <Checkbox
          className="min-h-11 items-center md:min-h-0"
          label="Только критические работы"
          checked={f.critical}
          onChange={(e) => setF({ ...f, critical: e.target.checked })}
        />
        {(
          [
            ['made', 'Составил'],
            ['checked', 'Проверил'],
            ['approved', 'Утвердил'],
          ] as const
        ).map(([k, label]) => (
          <LField key={k} label={label} hint="Пусто — строка для подписи от руки">
            <Input
              value={f[k]}
              maxLength={80}
              onChange={(e) => setF({ ...f, [k]: e.target.value })}
              className="max-md:h-11"
            />
          </LField>
        ))}
      </div>
    </Dialog>
  );
}
